import { render, staticRenderFns } from "./eleproducts.vue?vue&type=template&id=52f01944&"
import script from "./eleproducts.vue?vue&type=script&lang=js&"
export * from "./eleproducts.vue?vue&type=script&lang=js&"
import style0 from "./eleproducts.vue?vue&type=style&index=0&id=52f01944&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports